import { Link } from "react-router";
import { RouteFactory } from "@app/routePaths";
import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";

/**
 * Component to render Nominations Description of EE on homepage
 */
const EENominationsDescription = (): React.ReactElement => {
  return (
    <div
      className="flex w-full flex-row items-center text-center md:px-0 lg:mx-auto lg:w-10/12"
      data-testid="ee-nominations-description-component"
    >
      <IconFactory
        type={IconTypeEnum.apply}
        x={67}
        y={62}
        size={67}
        className="mr-18 mr-2 w-3/12 md:ml-2 md:mr-20 lg:mr-14 lg:w-auto"
      />

      <div className="mr-7 flex w-6/12 flex-col items-center justify-center gap-2 text-center font-public-sans text-gray-850 md:w-8/12 lg:w-auto">
        <h2 className="text-center align-middle font-poppins text-4xl font-medium !leading-[1.2] md:text-6xl lg:text-8xl lg:leading-tight">
          {"Applications for Emerging Enterprise Award and "}
          <br className="hidden md:inline" />
          {"Emerging Enterprise Sustainability Award are now "}
          <br className="hidden md:inline" />
          open
        </h2>

        <Link
          to={RouteFactory.eeApplyNowPage}
          target="_blank"
          className="rounded-full bg-gray-850 px-8 py-3 font-poppins text-base font-medium text-white hover:bg-gray-675"
        >
          Apply Now
        </Link>
      </div>
    </div>
  );
};

export default EENominationsDescription;
